export default "./images/survio-R6-XK-assets-reference-pl.png";